import Kfit from '../integrations/Kfit';

export const cancelTransaction = (id, params) => {
  return Kfit.put(`/v4/fave_payments/${id}`, params);
};
